import type { ReactNode } from 'react'
import s from './ContentWidth.module.scss'

/**
 * Wie breit der Inhalt einer Ansicht sein darf.
 *
 *   full     die ganze Breite — Listen, Dashboards, Tabellen
 *   medium   1040 px, mittig — Detailansicht mit zwei Spalten
 *   narrow    720 px, mittig — einspaltige Detailansicht, formularartig
 */
export type ContentSize = 'full' | 'medium' | 'narrow'

/**
 * Begrenzt den Inhalt und stellt ihn in die Mitte.
 *
 * Die ANSICHT entscheidet über ihre Breite, nicht das Layout: Eine Detailroute
 * wie `/instruments/:id` findet die Ansichtstabelle in AppLayout nicht — sie
 * vergleicht den Pfad exakt. Die Ansicht selbst weiß es immer.
 *
 * Auf kleinen Breiten greift `max-width` von sich aus nicht. Am Handy ändert
 * sich dadurch nichts, und es braucht keine Media-Query.
 */
export function ContentWidth({ size = 'full', children }: {
  size?: ContentSize
  children: ReactNode
}) {
  return <div className={s.area} data-size={size}>{children}</div>
}
